/* eslint-disable react/no-danger */

// Solution due to React issue with video displaying mute. Solution provided here:
// https://medium.com/@BoltAssaults/autoplay-muted-html5-video-safari-ios-10-in-react-673ae50ba1f5

import React from 'react';
import { Video } from '../../types/puppyGuide';
import { imgPath } from './constants';

interface VideoPlayerProps {
  baseClass?: string;
  videoClass: string;
  isAutoPlay: boolean;
  videoAttributes: Video;
}

const VideoPlayer = ({ baseClass, videoClass, isAutoPlay, videoAttributes }: VideoPlayerProps) => {
  const { src, type } = videoAttributes;
  return (
    <div
      className={baseClass}
      dangerouslySetInnerHTML={{
        __html: `
              <video autoPlay=${isAutoPlay} loop muted playsInline class=${videoClass}>
                  <source src=${imgPath}${src} type=${type} />
              </video>
          `,
      }}
    />
  );
};

export default VideoPlayer;
